import React, { useState, useEffect } from 'react';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const MultiBarChart = (p) => {
    const data = p.data ?? [];
    const config = {
        name: p?.config?.name ?? 'name',
        keys: p?.config?.keys ?? [],
    }

    const key1 = p.key1 ?? '';
    const key2 = p.key2 ?? '';

    const title = p.title ?? "";
    const color1 = p.color1 ?? "#8884d8";
    const color2 = p.color2 ?? "#82ca9d";

    const keys = p.keys;

    const maxWid = p.maxWid ?? false;


    useEffect(() => {

    }, []);
    return (
        <div className={maxWid ? 'col-lg-12 p-1 mb-3 mt-3' : 'col-lg-6 p-1 mb-3 mt-3'} style={{ height: `${p.height ?? 350}px` }}>
            <div className='col-lg-12 bg-white round-l shadow' style={{ height: `${p.height ?? 350}px` }}>
                <div className='col-lg-12 text-center text-bold text-l'>{title}</div>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={(p.height ?? 350) - 50}
                        data={data}
                        margin={{
                            left: 0,
                            bottom: 20,
                        }}
                    >
                        <CartesianGrid strokeDasharray="2 2" />
                        <XAxis dataKey={config.name} />
                        <YAxis />
                        <Tooltip />
                        {
                            config.keys.map((k, i) =>
                                <Bar key={k.key} dataKey={k.key} fill={k.color} activeBar={<Rectangle fill="#00ABD5" stroke="yellow" />} />
                            )
                        }
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default MultiBarChart;